import { type ComponentProps } from 'react'
import { ButtonGroup } from '@highlight/ui'
import { MessageFeedback } from '@renderer/components/feedback'

type PreviewFeedbackPillProps = ComponentProps<typeof MessageFeedback>

/** The hover card footer's thumbs, framed as one control at the footer buttons' size. */
export function PreviewFeedbackPill(props: PreviewFeedbackPillProps) {
  return (
    <ButtonGroup layout="shell" variant="outline">
      <MessageFeedback {...props} />
    </ButtonGroup>
  )
}
